import { FC, useEffect, useMemo, useState } from 'react'
import { IArpMedia } from '../../../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { deserializeSongFromStorage } from '../../../stores/song/SongStore'
import { formatEpochTimestamp } from '../../core/helpers/dates'
import { formatTime } from '../../player/PlayerUtils'
import {
  CurrentlyPlayingMediaInfo,
  InfoRow,
  ProfileCurrentlyPlayingTabs
} from './ProfileCurrentlyPlaying'

interface Props {
  song: IArpMedia
}

const CurrentlyPlayingSongProperties: FC<Props> = ({ song }) => {
  const arp = useMemo(() => {
    return deserializeSongFromStorage(song.metadata.arpeggiComposition)
  }, [song])
  const createTime = parseInt(song.createdAt)
  return (
    <>
      <InfoRow title="Original BPM">{song.metadata.bpm}</InfoRow>
      {song.metadata.genres[0] && <InfoRow title="Genre">{song.metadata.genres[0]}</InfoRow>}
      <InfoRow title="Key">{arp.key.displayName()}</InfoRow>
      <InfoRow title="Duration">{formatTime(arp.lengthInSeconds)}</InfoRow>
      {createTime && <InfoRow title="Mint Date">{formatEpochTimestamp(createTime)}</InfoRow>}
    </>
  )
}

const CurrentlyPlayingSongOverview: FC<Props> = ({ song }) => {
  return (
    <>
      <InfoRow title="Artist">{song?.user?.displayName}</InfoRow>
      <InfoRow title="Contract Address">{song?.contractAddress}</InfoRow>
      <InfoRow title="Token ID">{song?.tokenId}</InfoRow>
      <InfoRow title="Blockchain">Polygon</InfoRow>
    </>
  )
}

const CurrentlyPlayingSongInfo: FC<CurrentlyPlayingMediaInfo> = ({ tab, index }) => {
  const [song, setSong] = useState<IArpMedia>(null)

  useEffect(() => {
    ArpRegistry.getByIdAsync(index).then((data) => setSong(data))
  }, [index])

  return (
    <>
      {tab === ProfileCurrentlyPlayingTabs.OVERVIEW && song && (
        <CurrentlyPlayingSongOverview song={song} />
      )}
      {tab === ProfileCurrentlyPlayingTabs.PROPERTIES && song && (
        <CurrentlyPlayingSongProperties song={song} />
      )}
    </>
  )
}

export default CurrentlyPlayingSongInfo
